module.exports = __webpack_public_path__ + "79fa302f6565a2f3eb5f4889381f5048.pdf";